import { useQuery } from '@tanstack/react-query';
import { getRefereeStats } from '../services/stats.service';

// The referee's stat cards. Gated by `enabled` so only roles that actually answer clips (referee /
// federation_admin) fetch it — a super_admin has no stats and the endpoint would 403. 30s stale
// window matches the other user-scoped lists: instant on revisit, refetched quietly after an answer.
export function useRefereeStatsQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['referee-stats'],
    queryFn: getRefereeStats,
    enabled,
    staleTime: 30_000,
  });
}
